import { isProduction } from './constants'

// TODO [future] fixed type for now
export function postReactNativeMessage(message) {
  const action = {
    type: 'CONFIGURE_APP_BAR',
    payload: message || {},
  }
  return setTimeout(() => {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify(action))
    } catch (e) {
      if (
        !isProduction &&
        e.message !== "Cannot read property 'postMessage' of undefined"
      ) {
        console.warn('postReactNativeMessage error', e)
        console.log('action:', JSON.stringify(action))
      }
    }
  }, 0)
}

// * for testing ReactNativeWebView.postMessage behavior, uncomment the follow lines:

// if (!isProduction) {
//   if (!window.ReactNativeWebView) {
//     window.ReactNativeWebView = {
//       stack: [],
//       postMessage(message) {
//         window.ReactNativeWebView.stack.push(message)
//       },
//     }
//   }
// }
